(ns firebase.storage
  (:require 
    [firebase.core :as core :refer [ADMIN_SDK]]
    ["firebase/storage" :as storage]
    [promises.core :refer-macros [await->]]))

(defn instance [& {:keys [app url]}]
  (storage/getStorage (or app @core/app) url))

; client sdk
(when-not ADMIN_SDK
  (defn upload-file
    ([path file] (upload-file (instance) path file))
    ([storage-instance path file] 
     (-> (storage/uploadBytes (storage/ref storage-instance path) file)))))


; admin sdk style
(when ADMIN_SDK
  (defn get-metadata 
    ([path] 
     (get-metadata (instance) path))
    
    ([^js instance path]
     (let [file-ref (.. instance bucket (file path))]
       (await-> 
         (.getMetadata file-ref)
         (aget 0)
         (then [^js metadata]
               (js/console.log metadata) 
               (when metadata 
                 {:content-type (.-contentType metadata)
                  :hash         (.-md5Hash metadata)
                  :etag         (.-etag metadata)
                  :updated      (.-updated metadata)}))))))
  
  (defn upload-stream
    ([path metadata] 
     (upload-stream (instance) path metadata))
    ([^js instance path metadata]
     (.. instance bucket (file path) (createWriteStream (clj->js (into {} metadata))))))
  
  (defn download-stream 
    ([path] 
     (download-stream (instance) path))
    
    ([^js instance path]
     (.. instance bucket (file path) createReadStream)))
  
  (defn copy-file
    ([src-path dest-path]
     (copy-file (instance) src-path dest-path))
    
    ([^js instance src-path dest-path]
     (let [src-file (.. instance bucket (file src-path))
           dest-file (.. instance bucket (file dest-path))]
       (await-> 
         (.copy src-file dest-file)))))
  
  (defn delete-file
    ([path]
     (delete-file (instance) path))
    
    ([^js instance path]
     (let [file-ref (.. instance bucket (file path))]
       (await-> 
         (.delete file-ref)))))
  
  (defn move-file
    ([src-path dest-path]
     (move-file (instance) src-path dest-path))
    
    ([^js instance src-path dest-path]
     (await->
       (copy-file instance src-path dest-path)
       (then [_] (delete-file instance src-path)))))  ;; returns the copied file
  
  )
  
